(ns dashboard.services.document-viewer
  (:require [dashboard.components.file-preview :as file-preview]
            [dashboard.components.file-diff :as file-diff]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::fetch-file-preview-url
 (fn [{:keys [db]} [_ filename id selected-paragraph document-search-results]]
   (let [download-url (str "/api/policies/files/" (js/encodeURIComponent filename))]
     {:db (assoc db
                 :document-search
                 {:selected-paragraph selected-paragraph
                  :document-search-results document-search-results})
      :http-xhrio {:method          :get
                   :uri             (str download-url "/url")
                   :timeout         http-config/timeout
                   :response-format http-config/transit-response-format
                   :on-success      [::file-preview/show-file-preview
                                     download-url
                                     filename
                                     id]
                   :on-failure      [::ui/set-error "Could not get policy file URL"]}})))

(rf/reg-event-fx
 ::fetch-file-preview-url-for-diff
 (fn [{:keys [db]} [_ filename id selected-paragraph document-search-results]]
   (let [download-url (str "/api/policies/files/" (js/encodeURIComponent filename))]
     {:db (assoc db
                 :document-search
                 {:selected-paragraph selected-paragraph
                  :document-search-results document-search-results})
      :http-xhrio {:method          :get
                   :uri             (str download-url "/url")
                   :timeout         http-config/timeout
                   :response-format http-config/transit-response-format
                   :on-success      [::file-diff/show-file-diff
                                     download-url
                                     filename
                                     id]
                   :on-failure      [::ui/set-error "Could not get policy file URL"]}})))